import ByCampaign from './ByCampaign'

export default ByCampaign
